import React, { PropTypes } from 'react'
import CurrentWebinarItem from './CurrentWebinarItem'

const CurrentWebinars = ({
    webinars,
    nextPage,
    pagination,
    count
  }) => (
  <div>
    <div className="section_webinars_desc">
      <h2 className="main_title" id="current">CURRENT WEBINARS {count ? `(${count})` : '(0)'}</h2>
    </div>
    <div className="container_current row">
      {webinars}
    </div>
    {pagination && <a className="more_item" href="javascript:void(0)" onClick={nextPage}>LOAD MORE</a>}
    {!webinars.length &&
      <p className="has_no_items">There are no webinars currently running.</p>}
  </div>
)

CurrentWebinars.propTypes = {
  webinar: PropTypes.obj,
  joinToWebinar: PropTypes.func
}

export default CurrentWebinars



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/CurrentWebinars/CurrentWebinars.js
 **/